<template>
  <div>
    <div class="overlay" v-show="show" @click.stop="toogleShow"></div>
    <div v-if="show">
      <!-- 安卓提示框-->
      <div class="androidhintbox" v-if="config.isAndroid || config.isHarmonyOS">
        <!-- <div class="call-close"></div> -->
        <div class="contentbutton_box">
          <div class="contentimgbox">
            <ul class="hintbox">
              <li>
                <p class="hintbox_desc">1.请点击该页右上角</p>
                <div class="hinticonbox">
                  <img src="../../assets/images/share-black.png" alt />
                </div>
              </li>
              <li>
                <p class="hintbox_desc">2.选择在“浏览器中打开”</p>
                <div class="hinticonbox">
                  <img src="../../assets/images/browsericon.png" alt />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- ios提示框 -->
      <div class="ioshintbox" v-if="config.isIOS">
        <!-- <div class="call-close"></div> -->
        <div class="contentbutton_box">
          <div class="contentimgbox">
            <ul class="hintbox">
              <li>
                <p class="hintbox_desc">1.请点击该页右上角</p>
                <div class="hinticonbox">
                  <img src="../../assets/images/share-white.png" alt />
                </div>
              </li>
              <li>
                <p class="hintbox_desc">2.选择在“Safari中打开”</p>
                <div class="hinticonbox">
                  <img src="../../assets/images/safariicon.png" alt />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareModal",
  data() {
    return {
      show: false,
      config: {}
    };
  },
  methods: {
    toogleShow() {
      this.show = !this.show;
      // console.log(this.show);
    }
  },
  created() {
    this.config = this.$browser();
    // console.log(this.config);
  }
};
</script>

<style lang="less" scoped>
.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.3);
}
.androidhintbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  z-index: 10000;
}
/* ios提示框 */
.ioshintbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  z-index: 10000;
}
.contentbutton_box {
  width: 100%;
  height: 100%;
  padding: 0 32px 0 32px;
  /* border: 1px solid red; */
  .contentimgbox {
    width: 311px;
    height: 155px;
    /* border          : 1px solid red; */
    position: relative;
    background: url("../../assets/images/xingxing.png");
    background-size: 100%;
    background-position: 0% 0%;
    .hintbox {
      width: 311px;
      height: 110px;
      /* border: 1px solid red; */
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 15px 22px;
      > li {
        width: 100%;
        height: 40px;
        /* border      : 1px solid red; */
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .hintbox_desc {
        font-size: 18px;
        height: 40px;
        line-height: 40px;
        /* border  : 1px solid red; */
        font-weight: bold;
        color: #333333;
      }

      .hinticonbox {
        width: 31px;
        height: 31px;
        margin-left: 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sharemodal/sharemodal.vue